<div
  class="card {{ !isFromLead && 'h-100' }} border-{{ border }} {{ cardBorder }} {{ contractBorder }} {{
    heading == 'Features' || background ? 'overlay-background' : ''
  }} {{ bgwhite ? 'bg-white' : '' }}"
  [ngStyle]="{ height: !isCollapsed ? '100%' : 'auto' }">
  <div class="card-header {{ padding ? 'px-3 pb-3rem' : mobToggle ? 'p-2' : cardpadding ? 'pt-2' : 'py-3' }} bg-none border-0 {{ cardHeader }}">
    <div class="d-flex justify-content-between align-items-center cursor-pointer" (click)="onHeaderClick()">
      <div class="heading boxHeadingText {{ headingClassName }}" (click)="isLeadContact ? openContactPopup(isLeadContact, $event) : ''">
        <p class="f-14 _fw-600">{{ heading }}</p>
      </div>
      <div class="action d-flex align-items-center">
        <img class="ml-3 cursor-pointer pi pi-angle-left" *ngIf="IsExpandedHorizontally" [src]="images?.expand_right_icon" />
        <p class="ml-3 cursor-pointer" *ngIf="isContact" (click)="openContactPopup(isContact)">
          {{ isContact?.first_name }}
        </p>
        <button class="mr-2 _view-btn p-2 h-auto {{ plusClassName }}" type="button" (click)="onClickEmitEventHandler($event)" *ngIf="AddNew">
          <i class="pi pi-plus f-12"></i>
        </button>
        <ng-container *ngIf="isFromLead; else notFromLead2">
          <i
            class="lead-collapse-box cursor-pointer pi {{ isCollapsed ? 'pi-angle-down' : 'pi-angle-up' }}"
            (click)="onChevronClick($event)"></i>
        </ng-container>
        <ng-template #notFromLead2>
          <div class="ml-3 icon-style {{ background ? 'bg-white' : '' }}">
            <i
              class="f-18 cursor-pointer pi {{ isCollapsed ? 'pi-angle-down' : 'pi-angle-up' }}"
              aria-controls="collapseEvent"
              (click)="onChevronClick($event)"></i>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div
    class="card-body pt-0 {{ cardBodyPadding }} {{ MaxHeight !== 'auto' ? 'overflow-hidden pb-0' : '' }}"
    [ngStyle]="{ 'max-height': !showMoreExpanded ? MaxHeight : '' }"
    [hidden]="isCollapsed">
    <ng-content></ng-content>
  </div>

  <div *ngIf="MaxHeight !== 'auto' && !isCollapsed" class="d-flex show-minimize-gradient"></div>

  <div *ngIf="MaxHeight !== 'auto' && !isCollapsed" class="d-flex justify-content-center pb-3 cursor-pointer">
    <div class="text-primary" (click)="showMoreExpanded = !showMoreExpanded">Show {{ showMoreExpanded ? 'less' : 'more' }}</div>
  </div>
</div>
